define(['jquery'], function($) {
	return function(app, _) {
		$.extend(app, {
			counter: function(id) {
				if(id) {
					(new Image).src = '//rs.mail.ru/d'+ id +'.gif?rnd='+ Math.random();
				}
			}
		})
	}
}) 
